import { ApplicationRef, ComponentFactoryResolver, Injectable, Injector } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CustomCompileService {
  constructor(
    private readonly injector: Injector,
    private readonly resolver: ComponentFactoryResolver,
    private readonly appRef: ApplicationRef,
  ) { }

  compile(component, onAttach): any {
    const compFactory = this.resolver.resolveComponentFactory(component);
    const compRef = compFactory.create(this.injector);
    if (onAttach) { onAttach(compRef); }
    this.appRef.attachView(compRef.hostView);
    compRef.onDestroy(() => this.appRef.detachView(compRef.hostView));
    const div = document.createElement('div');
    div.appendChild(compRef.location.nativeElement);
    return div;
  }
}
